import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {PermissionsProvider, Select} from '@/components';
import type {AfriexQueryParams} from '@/types';
import {AfriexFeatureStatus} from '@/types';

import FeatureUpdateButton from './FeatureUpdateButton';

export type BusinessFeaturesFiltersProps = {
  currentFilters: AfriexQueryParams;
  clearFilters?: () => void;
  selectCurrentFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
};

const BusinessFeaturesFilters: React.FC<BusinessFeaturesFiltersProps> = ({
  currentFilters,
  selectCurrentFilters,
}) => {
  return (
    <div className="mt-5 w-full">
      <div className="flex flex-wrap gap-3 items-center md:justify-end">
        {/* Status Select Box */}
        <Select
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            selectCurrentFilters('status', e.target.value || undefined)
          }
          value={currentFilters.status ?? ''}
          name="status"
          dataCy="merchant-features-status-filter"
          options={[
            {key: 'All', value: ''},
            {key: 'Active', value: AfriexFeatureStatus.Active},
            {key: 'Inactive', value: AfriexFeatureStatus.Inactive},
          ]}
          placeholder="Filter by status"
        />
        <PermissionsProvider permission={AfriexAdminPermission.FeatureManage}>
          <FeatureUpdateButton dataCy="merchant-features-create" />
        </PermissionsProvider>
      </div>
    </div>
  );
};

export default BusinessFeaturesFilters;
